<template>
  <div class="usage basic">
    <div class="usage-content">
      <div class="usage-content-doc" v-html="doc1"></div>
    </div>
  </div>
</template>

<script>
import doc1 from '../docs/basic.md'

export default {
  data () {
    return {
      doc1
    }
  },
  mounted () {
    ;['basic-usage', 'pure-string', 'html-string', 'slot-events', 'queue'].forEach((c, index) => {
      document.querySelector(`.${c}-demo`).addEventListener('click', this['demo' + index])
    })
    ;['top', 'right', 'bottom', 'left'].forEach(pos => {
      document.querySelector(`.slot-${pos}`).addEventListener('click', () => {
        this.demoPos(pos)
      })
    })
  },
  methods: {
    demo0 () {
      tour.focus({
        el: '#basic-usage'
      })
    },
    demo1 () {
      tour.focus({
        el: '#pure-string',
        slot: 'This is a pure string'
      })
    },
    demo2 () {
      tour.focus({
        el: '#html-string',
        slot: `
          <div>
            <p>This is a html string</p>
          </div>
        `
      })
    },
    demoPos (pos) {
      const demo3Tour = new Smartour()
      demo3Tour.focus({
        el: `.slot-${pos}`,
        slot: pos,
        options: {
          slotPosition: pos
        }
      })
    },
    demo3 () {
      tour.focus({
        el: '.slot-events-demo',
        options: {
          slotPosition: 'right'
        },
        slot: `
          <button class="occur-1 demo-btn">
            Click here to occur an alert event
          </button>
          <button class="occur-2 demo-btn">
            Click here to occur another event
          </button>
        `,
        keyNodes: [{
          el: '.occur-1',
          event: () => { alert('Event!!') }
        }, {
          el: '.occur-2',
          event: () => { alert('Another event!!') }
        }]
      })
    },
    demo4 () {
      const tour = new Smartour()
      tour.queue([{
        el: '.li-1',
        options: {
          layerEvent: tour.next.bind(tour)
        },
        slot: 'This is the 1st line.'
      }, {
        el: '.li-2',
        options: {
          layerEvent: tour.next.bind(tour)
        },
        slot: 'This is the 2nd line.'
      }, {
        el: '.li-3',
        options: {
          layerEvent: tour.next.bind(tour)
        },
        slot: 'This is the 3rd line.'
      }]).run()
    }
  }
}
</script>

<style lang="less" scoped>
.usage {
  &-content {
    width: 100%;
    max-width: 960px;
  }
}
</style>
